import "../../App.css";
import "./Gallery.css";
import {Link} from "react-router-dom";
import { useEffect, useState } from "react";
import SimpleReactLightbox from "simple-react-lightbox";
import {SRLWrapper} from "simple-react-lightbox";

const Gallery = () =>{

const images = [

    {id:"1", name:"1.jpg", tag:"Podluzany"},
    {id:"2", name:"2.jpg", tag:"Podluzany"},
    {id:"3", name:"3.jpg", tag:"Podluzany"},
    {id:"5", name:"5.jpg", tag:"Podluzany"},
    {id:"6", name:"6.jpg", tag:"Podluzany"},
    {id:"7", name:"7.jpg", tag:"Podluzany"},
    {id:"8", name:"8.jpg", tag:"Podluzany"},
    {id:"9", name:"9.jpg", tag:"Podluzany"},

    {id:"11", name:"2.jpg", tag:"Kulturne_aktivity"},
    {id:"12", name:"3.jpg", tag:"Kulturne_aktivity"},
    {id:"13", name:"4.jpg", tag:"Kulturne_aktivity"},
    {id:"14", name:"5.jpg", tag:"Kulturne_aktivity"},
    {id:"15", name:"6.jpg", tag:"Kulturne_aktivity"},
    {id:"16", name:"7.jpg", tag:"Kulturne_aktivity"},
    {id:"17", name:"8.jpg", tag:"Kulturne_aktivity"},
    {id:"18", name:"9.jpg", tag:"Kulturne_aktivity"},
    {id:"19", name:"10.jpg", tag:"Kulturne_aktivity"},
    {id:"20", name:"11.jpg", tag:"Kulturne_aktivity"},
    {id:"21", name:"12.jpg", tag:"Kulturne_aktivity"},
    {id:"22", name:"13.jpg", tag:"Kulturne_aktivity"},
   
    {id:"24", name:"2.jpg", tag:"Kruzkove_aktivity"},
    {id:"25", name:"3.jpeg", tag:"Kruzkove_aktivity"},
    {id:"26", name:"4.jpeg", tag:"Kruzkove_aktivity"},
    {id:"27", name:"5.jpeg", tag:"Kruzkove_aktivity"},
    {id:"28", name:"6.jpeg", tag:"Kruzkove_aktivity"},
    {id:"29", name:"7.jpeg", tag:"Kruzkove_aktivity"},
    {id:"30", name:"8.jpeg", tag:"Kruzkove_aktivity"},

    {id:"31", name:"1.jpg", tag:"Pohybove_aktivity"},
    {id:"32", name:"3.jpeg", tag:"Pohybove_aktivity"},
    {id:"33", name:"4.jpeg", tag:"Pohybove_aktivity"},
    {id:"34", name:"5.jpeg", tag:"Pohybove_aktivity"},
    {id:"35", name:"6.jpeg", tag:"Pohybove_aktivity"},
    {id:"36", name:"7.jpeg", tag:"Pohybove_aktivity"},
    {id:"37", name:"8.jpeg", tag:"Pohybove_aktivity"} 

];

const[tag, setTag] = useState("");
const[filteredImages, setFilteredImages] = useState([]);


useEffect(() =>{
    tag === "" ? setFilteredImages(images) : setFilteredImages(images.filter(image => image.tag === tag));
},[tag]);

    return(
        <div className = "cards">
            <div className='cards__container'>
                <h1>Fotogaléria</h1>
                <div className='cards__wrapper'>
                    <ul className='cards__items'>

                        {/* Podluzany Gallery */}
                        <li className='cards__item' onClick={() => setTag("Podluzany")}>
                            <SimpleReactLightbox>
                            <SRLWrapper>
                            <Link className='cards__item__link' to="/Gallery">
                                <figure className='cards__item__pic-wrap' data-category="Prostredie">
                                    <img
                                    className='cards__item__img'
                                    alt='Podluzany'
                                    src="Galleries/Podluzany/4.jpg"
                                    />
                                </figure>
                                <div className='cards__item__info'>
                                    <h5 className='cards__item__text'>Zariadenie</h5>
                                </div>
                            </Link>
                            <div>
                                {filteredImages.map( image => (
                                    <div className="gall-item" key={image.id}>
                                        <img src={`Galleries/${image.tag}/${image.name}`} alt={image.tag}/>
                                    </div>
                                    ))}
                            </div>
                            </SRLWrapper>
                            </SimpleReactLightbox>
                        </li>

                        {/* Kulturne_aktivity Gallery */}
                        <li className='cards__item' onClick={() => setTag("Kulturne_aktivity")}>
                            <SimpleReactLightbox>
                            <SRLWrapper>
                            <Link className='cards__item__link' to="/Gallery">
                                <figure className='cards__item__pic-wrap' data-category="Udalosť">
                                    <img
                                    className='cards__item__img'
                                    alt='Kulturne_aktivity'
                                    src="Galleries/Kulturne_aktivity/1.jpg"
                                    />
                                </figure>
                                <div className='cards__item__info'>
                                    <h5 className='cards__item__text'>Kultúrne aktivity</h5>
                                </div>
                            </Link>
                            <div>
                                {filteredImages.map( image => (
                                    <div className="gall-item" key={image.id}>
                                        <img src={`Galleries/${image.tag}/${image.name}`} alt={image.tag}/>
                                    </div>
                                    ))}
                            </div>
                            </SRLWrapper>
                            </SimpleReactLightbox>
                        </li>

                        {/* Kruzkove_aktivity Gallery */}
                        <li className='cards__item' onClick={() => setTag("Kruzkove_aktivity")}>
                            <SimpleReactLightbox>
                            <SRLWrapper>
                            <Link className='cards__item__link' to="/Gallery">
                                <figure className='cards__item__pic-wrap' data-category="Aktivity">
                                    <img
                                    className='cards__item__img'
                                    alt='Kruzkove_aktivity'
                                    src="Galleries/Kruzkove_aktivity/1.jpg"
                                    />
                                </figure>
                                <div className='cards__item__info'>
                                    <h5 className='cards__item__text'>Krúžkové aktivity</h5>
                                </div>
                            </Link>
                            <div>
                                {filteredImages.map( image => (
                                    <div className="gall-item" key={image.id}>
                                        <img src={`Galleries/${image.tag}/${image.name}`} alt={image.tag}/>
                                    </div>
                                    ))}
                            </div>
                            </SRLWrapper>
                            </SimpleReactLightbox>
                        </li>

                        {/* Pohybove_aktivity Gallery */}
                        <li className='cards__item' onClick={() => setTag("Pohybove_aktivity")}>
                            <SimpleReactLightbox>
                            <SRLWrapper>
                            <Link className='cards__item__link' to="/Gallery">
                                <figure className='cards__item__pic-wrap' data-category="Aktivity">
                                    <img
                                    className='cards__item__img'
                                    alt='Pohybove_aktivity'
                                    src="Galleries/Pohybove_aktivity/2.jpg"
                                    />
                                </figure>
                                <div className='cards__item__info'>
                                    <h5 className='cards__item__text'>Pohybové aktivity</h5>
                                </div>
                            </Link>
                            <div>
                                {filteredImages.map( image => (
                                    <div className="gall-item" key={image.id}>
                                        <img src={`Galleries/${image.tag}/${image.name}`} alt={image.tag}/>
                                    </div>
                                    ))}
                            </div>
                            </SRLWrapper>
                            </SimpleReactLightbox>
                        </li>                        
                        
                    </ul>
                </div>
            </div>   
        </div>
    )
}

export default Gallery;